module.exports = __webpack_public_path__ + "images/emoji/droplet.1a1f4f00e76f2c2c0306.png";